import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=52c45d00&scoped=true&"
import script from "./Lightbox.vue?vue&type=script&lang=js&"
export * from "./Lightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c45d00",
  null
  
)

export default component.exports